import React, {FC, Fragment} from "react";
import Link from "next/link";
import {ArrowRoundedRight6x9Svg} from "../../svg";
import {useRouter} from "next/router";
import cls from "./InnerPageProduct/customInnerPage.module.scss"
import Script from "next/script";
import {domainUrl} from "../../helper";

export const schemaPageHeader = (dbName: string, asPath: string, breadcrumb: Array<{ title: string; url: string }>) => {
    return {
        "@context": `https://schema.org/`,
        "@type": "BreadcrumbList",
        "name": "Breadcrumb",
        "url": domainUrl(dbName + asPath),
        "itemListElement": breadcrumb.map((item, index) => ({
            "name": "Breadcrumb",
            "@type": "ListItem",
            "position": index + 1,
            "item": {
                "url": item.url,
            },
        })),
    }
}

interface IProps {
    breadcrumb: Array<{ title: string; url: string }>,
    dbName: string
}

const BreadcrumbHeader: FC<IProps> = ({breadcrumb, dbName}) => {
    const {asPath} = useRouter();
    const schema = schemaPageHeader(dbName, asPath, breadcrumb)
    const [{title: firstTitle, url: firstUrl}, {title: lastTitle}] = breadcrumb;
    return (
        <Fragment>
            <Script
                id={schema.name}
                type="application/ld+json"
                dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
                defer
            />
            <div className={cls["page-header"]}>
                <div className={`${cls["page-header__container"]} container`}>
                    <div className={cls["page-header__breadcrumb"]}>
                        <nav aria-label="breadcrumb">
                            <ol className={cls["breadcrumb"]}>
                                <li className={cls["breadcrumb-item"]}>
                                    <Link href={firstUrl}><a>{firstTitle}</a></Link>
                                    <ArrowRoundedRight6x9Svg className={cls["breadcrumb-arrow"]}/>
                                </li>
                                <li
                                    className={`${cls["breadcrumb-item"]} ${cls["breadcrumb-item-active"]}`}
                                    aria-current="page"
                                >
                                    {lastTitle}
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default BreadcrumbHeader;
